var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBookSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.32 18.78c-1.16-.63-3.21-1.31-4.5-1.48l-.19-.03c-.98-.12-1.76-1-1.76-2.01v-7.7c0-.57.24-1.12.65-1.5.42-.38.96-.57 1.54-.52 1.46.12 3.58.82 4.83 1.6l.1.06.04-.03c1.26-.79 3.38-1.5 4.85-1.63h.1c.52-.05 1.08.15 1.49.52.42.38.65.91.65 1.49v7.69c0 1-.78 1.88-1.77 2.01l-.21.03c-1.28.17-3.34.85-4.48 1.48-.19.14-.42.19-.66.19-.24 0-.48-.06-.68-.17zM6.54 7.18c-.11.1-.16.24-.16.39v7.7c0 .24.22.49.45.52l.19.03c1.46.2 3.7.93 5 1.64 1.21-.7 3.46-1.45 4.93-1.64l.22-.03c.23-.03.45-.28.45-.52V7.58c0-.16-.06-.29-.16-.39a.536.536 0 0 0-.41-.13h-.1c-1.16.1-3.07.74-4.11 1.4l-.1.06c-.44.27-1.06.27-1.48.01l-.15-.09c-1.05-.66-2.96-1.29-4.17-1.39h-.05a.52.52 0 0 0-.35.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.66V8.1c0-.41.34-.75.75-.75s.75.34.75.75v9.56a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBookSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-book-square.44dfbf6338b80f74aae80d614227fef3.svg";
export { ForwardRef as ReactComponent };